import React from 'react'
import { PopperPlacementType } from '@material-ui/core'

export type PeriodTypes = 'month' | 'quarter' | 'year' | 'day'

export const PeriodTypeOptions: PeriodTypes[] = ['month', 'quarter', 'year', 'day']

export const defaultLabelFormat = 'MMM, YYYY'

export interface DateRange {
  startDate: string
  endDate: string
}

export interface PeriodSelectorOptions {
  [key: string]: {
    label: string
    dateRange: {
      startDate: string
      endDate: string
    }
  }[]
}

export interface PeriodSelectorPreset {
  label: string
  dateRange: DateRange
}

export interface PeriodSelectorProps {
  placement?: PopperPlacementType
  onUpdateDateRange: (periodType: PeriodTypes, periodRange: DateRange) => void
  rangeRestriction?: DateRange
  defaultSelectedRange?: DateRange
  allowedPeriodTypes?: PeriodTypes[]
  presets?: PeriodSelectorPreset[]
  defaultPeriodType?: PeriodTypes
  maxLength?: {
    maxLengthPeriodType: PeriodTypes
    length: number
  }
  time?: boolean
}

export interface PeriodSelectorState {
  dateRange: DateRange
  choosingStart: boolean
  chosenPreset?: PeriodSelectorPreset
  periodType: PeriodTypes
  periodRestriction?: PeriodTypes
  options?: PeriodSelectorOptions
}

export const defaultPeriodSelectorState: PeriodSelectorState = {
  choosingStart: true,
  periodType: 'month',
  dateRange: {
    startDate: '',
    endDate: '',
  },
}

export const defaultStartDate = '2012-05-12'

export interface DatePickerOptions {
  [key: string]: Array<{
    label: string
    dateRange: DateRange
  }>
}

//  DO NOT DELETE UNLESS - NOV 5, 2020
// export interface DatePickerOptions {
//   periodGroup: string; // The clickable category like the month name or the year name
//   options: Period[]; // The options underneath each category like days or months
// }
//
// export interface Period {
//   label: string;
//   dateRange: DateRange;
// }
